<template>
  <div
    class="tw-m-4 tw-bg-white tw-shadow-lg tw-text-left tw-rounded tw-px-8 tw-pt-2 tw-pb-8 tw-mb-4"
  >
    <div v-if="project && !loading">
      <div
        class="tw-flex tw-justify-between tw-w-auto"
        v-if="project.owner_id._id == company._id"
      >
        <v-alert
          v-if="project.initial_project_type == 'Listing' && !project.isPaid"
          dense
          border="left"
          type="warning"
          class="tw-mt-2"
        >
          You need to make payment on this project
        </v-alert>
        <paystack
          v-if="project.initial_project_type == 'Listing' && !project.isPaid"
          class="tw"
          :amount="amount"
          :email="email"
          :paystackkey="paystackkey"
          :reference="reference"
          :callback="callback"
          :close="close"
          :embed="false"
        >
          <span
            class="tw-bg-eko-orange hover:tw-bg-eko-dark tw-rounded tw-p-2 tw-text-white"
          >
            Make Payment</span
          >
        </paystack>
      </div>
      <div class="tw-flex tw-justify-between my-4">
        <p class="tw-mx-4 tw-block tw-mt-8 tw-font-bold tw-text-2xl">
          Project Name: {{ project.name }}
        </p>
        <v-menu left bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item v-if="project.owner_id._id == company._id">
              <v-list-item-title
                class="tw-cursor-pointer"
                @click="dialog = true"
                >Transfer Project</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <v-img
        class="white--text align-end"
        height="250px"
        :src="project.file.split(',')[0]"
        lazy-src="https://picsum.photos/id/11/100/60"
      >
      </v-img>
      <br />
      <div class="tw-rounded tw-overflow-hidden tw-mt-3 tw-p-8 tw-shadow-lg">
        <p
          class="tw-block tw-text-eko-orange tw-text-left tw-mt-4 tw-text-xl tw--mb-3 tw-font-bold"
        >
          Project Details
        </p>

        <p class="tw-mx-4 tw-block">
          <strong>Description:</strong> {{ project.description }}
        </p>
        <p class="tw-px-4"><strong>Address:</strong> {{ project.address }}</p>
        <p class="tw-block tw-px-4">
          <strong>Sector:</strong> {{ project.sector }}
        </p>
        <!-- <p class="tw-block tw-px-4" v-if="project.project_type">
          <strong>Status:</strong> {{ project.project_type }}
        </p> -->
      </div>

      <!-- <div
        class="tw-rounded tw-overflow-hidden tw-mt-3 tw-p-8 tw-shadow-lg"
        v-if="project.verification_number"
      >
        <p
          class="tw-block tw-text-eko-orange tw-text-left tw-mt-4 tw-text-xl tw--mb-3 tw-font-bold"
        >
          2. Verification Details
        </p>
        <div class="tw-flex tw-flex-wrap">
          <section class="tw-w-full md:tw-w-1/2">
            <p class="tw-block tw-px-4">
              <strong>Verification Date:</strong>
              {{ project.verification_date }}
            </p>

            <p class="tw-block tw-px-4" v-if="project.verification_number">
              <strong>Verification Number:</strong>
              {{ project.verification_number }}
            </p>

            <p class="tw-block tw-px-4" v-if="project.validated_by">
              <strong>Validated by:</strong> {{ project.validated_by }}
            </p>
          </section>
          <section class="tw-w-full md:tw-w-1/2">
            <p class="tw-block tw-px-4" v-if="project.approved_by">
              <strong>Approved by:</strong> {{ project.approved_by }}
            </p>

            <p class="tw-block tw-px-4" v-if="project.validation_number">
              <strong>Validation Number:</strong>
              {{ project.validation_number }}
            </p>
            <p class="tw-block tw-px-4" v-if="project.verified_by">
              <strong>Verified by:</strong> {{ project.verified_by }}
            </p>
          </section>
        </div>
      </div> -->

      <!-- <div
        class="tw-rounded tw-overflow-hidden tw-mt-3 tw-p-8 tw-shadow-lg"
        v-if="project.certification_report"
      >
        <p
          class="tw-block tw-text-eko-orange tw-text-left tw-mt-4 tw-text-xl tw--mb-3 tw-font-bold"
        >
          3. Certification Details
        </p>

        <div class="tw-flex tw-flex-wrap">
          <section class="tw-w-full md:tw-w-1/2">
            <p class="tw-block tw-px-4" v-if="project.certified_by">
              <strong>Certified by:</strong> {{ project.certified_by }}
            </p>

            <p class="tw-block tw-px-4" v-if="project.certified_number">
              <strong>Certification Number:</strong>
              {{ project.certified_number }}
            </p>
            <p class="tw-block tw-px-4" v-if="project.certified_date">
              <strong>Certification Date:</strong> {{ project.certified_date }}
            </p>

            <p class="tw-block tw-px-4" v-if="project.life_cycle">
              <strong>Life Cycle:</strong> {{ project.life_cycle }}
            </p>
          </section>

          <section class="tw-w-full md:tw-w-1/2">
            <p
              class="tw-block tw-px-4"
              v-if="project.carbon_reduction_capacity"
            >
              <strong>Total Carbon Reduction Capacity:</strong>
              {{ project.carbon_reduction_capacity }} tCO2e
            </p>

            <p class="tw-block tw-px-4" v-if="project.carbon_balance">
              <strong>Carbon Balance:</strong>
              {{ project.carbon_balance }} tCO2e
            </p>

            <p class="tw-block tw-px-4" v-if="project.price">
              <strong>Price(₦):</strong> {{ project.price }}
            </p>

            <p class="tw-block tw-px-4" v-if="project.certification_report">
              <a :href="project.certification_report" target="_blank"
                >View Certification Report</a
              >
            </p>
          </section>
        </div>
      </div> -->

      <vue-element-loading
        v-if="loading"
        :active="loading"
        :is-full-screen="true"
      />
    </div>

    <v-row justify="center">
      <v-dialog v-model="dialog" scrollable max-width="400px">
        <v-card>
          <v-card-title>Transfer Project</v-card-title>
          <v-divider></v-divider>
          <div class="tw-flex tw-flex-wrap tw-px-4 tw-mb-6 tw-mt-8">
            <div class="tw-w-full tw-mb-6 md:tw-mb-0">
              <label
                class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                for="tonnage"
              >
                Enter email of new owner
              </label>
              <input
                class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none"
                id="tonnage"
                type="text"
                placeholder="e.g janedoe@gmail.com"
                v-model="data.email"
              />
            </div>
            <p v-if="errors.email" class="tw-text-xs tw-text-red-500">
              Please enter email
            </p>
          </div>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="dialog = false"
              >Close</v-btn
            >
            <v-btn @click.prevent="transferProject()">Transfer</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios';
import paystack from 'vue-paystack';
export default {
  components: {
    paystack
  },
  data() {
    return {
      user: {},
      dialog: false,
      errors: {},
      loading: true,
      token: '',
      project: null,
      data: {},
      company: {},
      paystackkey:
        process.env.NODE_ENV === 'development'
          ? process.env.VUE_APP_PAYSTACK_TEST_KEY
          : process.env.VUE_APP_PAYSTACK_LIVE_KEY, //paystack public key,
      email: '', // Customer email,
      amount: 0 // in kobo
    };
  },
  mounted() {
    this.token = localStorage.getItem('eko-carbon-token');
    this.user = JSON.parse(localStorage.getItem('eko-carbon-user'));
    this.company = JSON.parse(localStorage.getItem('eko-carbon-company'));
    this.email = this.user.email;
    this.getProject();
  },
  computed: {
    reference() {
      let text = '';
      let possible =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

      for (let i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    }
  },
  methods: {
    callback: function(response) {
      console.log(response);
      this.makePayment();
    },
    close: function() {
      console.log('Payment closed');
    },
    getProject() {
      const self = this;
      axios
        .get(`${this.$baseUrl}/project/get/${this.$route.params.id}`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.token}`
          }
        })
        .then(response => {
          this.project = response.data.project;
          this.amount = 100 * parseInt(this.project.price);
          self.loading = false;
          self.success = true;
        })
        .catch(error => {
          self.loading = false;
          self.error = true;
          console.log(error);
        });
    },
    transferProject() {
      this.errors = {};
      this.loading = true;
      const self = this;
      let deny = false;
      if (!this.data.email) {
        this.errors.email = true;
        deny = true;
      }

      if (deny) {
        return;
      }

      this.data.owner_id = this.project.owner_id._id;
      this.data._id = this.project._id;
      axios
        .post(`${this.$baseUrl}/project/transfer`, this.data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.token}`
          }
        })
        .then(response => {
          // this.project = response.data.project;
          console.log(response);
          self.$swal('Success!', 'Project Transferred Successfully', 'success');
          self.loading = false;
          self.success = true;
          self.dialog = false;
        })
        .catch(error => {
          self.loading = false;
          self.error = true;
          let err_msg = error.response.data
            ? error.response.data.message
            : 'An error occured';
          self.$swal('Error!', err_msg, 'error');
        });
    },
    makePayment() {
      const self = this;
      let data = {
        project_id: this.project._id
      };
      axios
        .post(`${this.$baseUrl}/payment/project`, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.token}`
          }
        })
        .then(response => {
          console.log(response.data);
          self.$swal('Success!', 'Project added successfully!', 'success');
        })
        .catch(error => {
          self.loading = false;
          self.error = true;
          this.error = error;
          let err_msg = error.response.data
            ? error.response.data.message
            : 'An error occured';
          self.$swal('Error!', err_msg, 'error');
        });
    }
  }
};
</script>

<style lang="css" scoped>
.add-btn {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin: 20px;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  font-size: 36px;
}
.my-img {
  width: 50%;
  height: 50%;
  margin: auto;
}
</style>
